import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {BasicDialog} from '../../../../../components/common/dialogs/basicDialog';

/*
 * Styles.
 */

export const StyledRulesImpactHeadline = styled.h2`
  text-align: center;
  font-weight: ${fontWeights.normal};
  font-size: ${fontSizes.large};
`;

export const StyledRulesImpactList = styled.div`
  width: 660px;
  padding: 20px 0;
`;

export const StyledRulesImpactDialog = styled(BasicDialog)`
  overflow: auto;
  width: 700px;
  max-height: calc(100vh - 40px);
`;
